interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

function LoadingSpinner({ size = 'md', className = '' }: LoadingSpinnerProps) {
  const sizeClasses = {
    sm: 'claude-spinner-sm',
    md: 'claude-spinner-md',
    lg: 'claude-spinner-lg',
  };

  return (
    <div
      className={`claude-spinner ${sizeClasses[size]} ${className}`}
    />
  );
}

export default LoadingSpinner;
